const LookBottomIcon = /*#__PURE__*/ [
  ["path", { d: "M10 17C10.5788 17.3167 11.2647 17.5 12 17.5C12.7353 17.5 13.4212 17.3167 14 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.00673 13H9M15 13H14.9933", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", key: "1" }],
  ["path", { d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { LookBottomIcon as default };
//# sourceMappingURL=LookBottomIcon.js.map
